"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectHeading = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
exports.SelectHeading = function (_a) {
    var children = _a.children, className = _a.className, otherProps = tslib_1.__rest(_a, ["children", "className"]);
    return (react_1.default.createElement("div", tslib_1.__assign({ className: classnames_1.default("gd-select-heading gd-list-item gd-list-item-header", className) }, otherProps), children));
};
//# sourceMappingURL=SelectHeading.js.map